import React from "react";

import {
  Flag as FlagIcon,
  Height as HeightIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { Box, Theme, Typography, useTheme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import WeightIcon from "@/components/Icons/WeightIcon";

const useStyles = makeStyles()((theme: Theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: "bold",
  },

  caption: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },

  noLineHeight: {
    lineHeight: 0,
  },

  whiteBackground: {
    display: "flex",
    backgroundColor: theme.palette.common.white,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#DEE6F0",
    borderRadius: "4px",
  },

  secondaryText: {
    marginLeft: theme.spacing(2),
  },

  row: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
}));

type Props = {
  icon: "height" | "weight" | "goal-weight" | "ideal-weight";
  rowStyle?: boolean;
  title: string;
  text: string;
  secondaryText?: string;
};

const AccordionSummaryItem: React.FC<Props> = ({
  icon,
  rowStyle,
  title,
  text,
  secondaryText,
}) => {
  const { classes, cx } = useStyles();
  const theme = useTheme();
  return (
    <Box
      className={classes.whiteBackground}
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      justifyContent="center"
      py={1}
      px={2}
      marginLeft={theme.spacing(1)}
    >
      {icon === "height" && <HeightIcon htmlColor="#B8BEC9" />}
      {icon === "weight" && <WeightIcon />}
      {icon === "ideal-weight" && <CheckCircleIcon htmlColor="#B8BEC9" />}
      {icon === "goal-weight" && <FlagIcon htmlColor="#B8BEC9" />}
      <Box p={2} ml={theme.spacing(2)} className={rowStyle ? classes.row : ""}>
        <Typography
          className={cx(classes.caption, {
            [classes.noLineHeight]: rowStyle,
          })}
        >
          {title}
        </Typography>
        <Box display="flex" alignItems="center" justifyContent="flex-start">
          <Typography className={classes.heading}>{text}</Typography>
          {secondaryText && (
            <Typography
              variant="caption"
              color="textSecondary"
              className={classes.secondaryText}
            >
              {secondaryText}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AccordionSummaryItem;
